module.exports = __webpack_public_path__ + "static/media/nz.96d4a170.svg";